import { render, staticRenderFns } from "./OperatnResidenzaInfo.vue?vue&type=template&id=6b442e24&"
import script from "./OperatnResidenzaInfo.vue?vue&type=script&lang=ts&"
export * from "./OperatnResidenzaInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports